import { clone, path, pathOr } from 'ramda';
import {
	CLEAR_IMPORT_JOBS,
	CLEAR_IMPORT_JOB_UPDATE_ERRORS,
	CLEAR_IMPORT_JOB_CREATE_ERRORS,
	GET_IMPORT_JOB,
	GET_IMPORT_JOBS,
	FETCH_IMPORT_JOB_FAILED,
	FETCH_IMPORT_JOBS_FAILED,
	FETCH_IMPORT_JOB_SUCCEEDED,
	FETCH_IMPORT_JOBS_SUCCEEDED,
	UPDATE_IMPORT_JOB,
	UPDATE_IMPORT_JOB_FAILED,
	UPDATE_IMPORT_JOB_SUCCEEDED,
	CREATE_IMPORT_JOB,
	CREATE_IMPORT_JOB_FAILED,
	CREATE_IMPORT_JOB_SUCCEEDED,
} from './importJob.action';
import { importJobsInitialState } from './importJob.initialState';

const createPendingState = (state, pendingType) => ({
	...state,
	[pendingType]: true,
});

const createErrorState = (state, pendingType, errorType, error) => ({
	...state,
	[pendingType]: false,
	[errorType]: error,
});

const clearErrorState = (state, errorType) => ({
	...state,
	[errorType]: null,
});

export const importJobReducer = (state = importJobsInitialState, action) => {
	switch (action.type) {
		case CLEAR_IMPORT_JOBS: {
			return {
				...state,
				...importJobsInitialState,
			};
		}

		case CLEAR_IMPORT_JOB_UPDATE_ERRORS: {
			return clearErrorState(state, 'updateError');
		}

		case CLEAR_IMPORT_JOB_CREATE_ERRORS: {
			return clearErrorState(state, 'createError');
		}

		case GET_IMPORT_JOB:
		case GET_IMPORT_JOBS: {
			return createPendingState(state, 'pendingFetch');
		}

		case FETCH_IMPORT_JOB_FAILED:
		case FETCH_IMPORT_JOBS_FAILED: {
			return createErrorState(state, 'pendingFetch', 'fetchError', action.payload);
		}

		case FETCH_IMPORT_JOB_SUCCEEDED: {
			const fetchedImportJobId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingFetch: false,
			};
			if (fetchedImportJobId) {
				newState.entities = {
					...state.entities,
					[fetchedImportJobId]: action.payload,
				};
			}

			return newState;
		}

		case FETCH_IMPORT_JOBS_SUCCEEDED: {
			const previousStateEntities = clone(state.entities);
			const data = pathOr([], ['payload', 'data'], action);
			const entities = data.reduce((accumulator, datum) => {
				accumulator[datum._id] = datum;

				return accumulator;
			}, previousStateEntities);

			return {
				...state,
				entities,
				pendingFetch: false,
			};
		}

		case UPDATE_IMPORT_JOB: {
			return createPendingState(state, 'pendingUpdate');
		}

		case UPDATE_IMPORT_JOB_FAILED: {
			return createErrorState(state, 'pendingUpdate', 'updateError', action.payload);
		}

		case UPDATE_IMPORT_JOB_SUCCEEDED: {
			const updatedImportJobId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingUpdate: false,
			};

			if (updatedImportJobId) {
				newState.entities = {
					...state.entities,
					[updatedImportJobId]: action.payload,
				};
			}

			return newState;
		}

		case CREATE_IMPORT_JOB: {
			return createPendingState(state, 'pendingCreate');
		}

		case CREATE_IMPORT_JOB_FAILED: {
			return createErrorState(state, 'pendingCreate', 'createError', action.payload);
		}

		case CREATE_IMPORT_JOB_SUCCEEDED: {
			const createdImportJobId = path(['payload', '_id'], action);
			const newState = {
				...state,
				pendingCreate: false,
			};

			if (!action.payload.initialImport) {
				newState.entities = { ...state.entities };
			} else {
				// at most one job is the initial import job at a time
				// so if this is an initial import job, we must clear that flag
				// from all other locally-known jobs on successful create
				newState.entities = {};
				for (const entity of Object.values(state.entities)) {
					const { initialImport, ...restOfEntity } = entity;
					newState.entities[restOfEntity._id] = restOfEntity;
				}
			}

			if (createdImportJobId) {
				newState.entities[createdImportJobId] = action.payload;
			}

			return newState;
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/importJobs/importJob.reducer.js